// extracted by mini-css-extract-plugin
export default {"anonymousAvatar":"UozSE3","withBorder":"NTmvdR","filter":"fS2rgq"};